import { observer } from 'mobx-react';
import { FormFieldLine } from '../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../components/inputs/input/input';
import { IValidationGroup } from '../../../../../../hooks/validation-group/validation-group-hook';
import ReveniCredentialsStore from '../../../stores/reveni-credentials-store';

interface IIntegrationProps {
    credentialsStore: ReveniCredentialsStore,
    vGroup: IValidationGroup,
}

const ReveniCredentials: React.FC<IIntegrationProps> = observer(({credentialsStore, vGroup}) => {
    return (
        <>
            <FormFieldLine 
                label='API key'
                note='Your reveni API key'
                required
                key='apiKey'
            >
                <Input
                    value={credentialsStore.apiKey}
                    placeholder=''
                    onChange={v => credentialsStore.apiKey = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine 
                label='Store uuid (your store uuid)'
                note=''
                required
                key='storeUuid'
            >
                <Input
                    value={credentialsStore.storeUuid}
                    placeholder=''
                    onChange={v => credentialsStore.storeUuid = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
        </>
    )
});

export default ReveniCredentials;
